import * as React from "react";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";

export interface TestFixedCommentsErrorProps {
    testsMissingComments: number[];
    onOk: () => void;
}

export const TestFixedCommentsError = ({ onOk, testsMissingComments }: TestFixedCommentsErrorProps) => {
    return (
        <>
            <div className="modal-body">
                <Alert show={true} category={AlertCategoryEnum.Danger}>Rejected tests '{testsMissingComments.join(', ')}' are missing test comments</Alert>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={() => onOk()}>OK</button>
            </div>
        </>
    );
}
